import type { ScreenTourMap } from './types';

/**
 * Inventario: productos, productos por ruta, entradas de mercancía, traslados, bajas, devoluciones y
 * existencias. Solo lo usan las sedes de objeto real (las que prestan productos).
 */
export const inventoryTours: ScreenTourMap = {
  '/inventory/products': {
    key: 'screen-products',
    steps: [
      { text: 'tours.products.welcome' },
      { text: 'tours.products.officeTypes' },
      { text: 'tours.products.byRoute', target: 'products-by-route' },
      { text: 'tours.products.new', target: 'products-new' },
      { text: 'tours.products.office', target: 'products-office' },
      { text: 'tours.products.search', target: 'products-search' },
      { text: 'tours.products.table', target: 'products' },
      { text: 'tours.products.pricing', target: 'products-col-price', whenMissing: 'center' },
      { text: 'tours.products.stock', target: 'products-col-stock', whenMissing: 'center' },
      { text: 'tours.products.select', target: 'products-col-title', whenMissing: 'center' },
      { text: 'tours.products.actions', target: 'products-actions', whenMissing: 'center' },
      { text: 'tours.products.export', target: 'products-export' },
    ],
  },
  '/inventory/products/new': {
    key: 'screen-product-new',
    steps: [
      { text: 'tours.productNew.welcome' },
      { text: 'tours.productNew.stepper', target: 'product-form-stepper' },
      { text: 'tours.productForm.data', target: 'product-form-data' },
      { text: 'tours.productForm.price', target: 'product-form-price' },
      { text: 'tours.productForm.utility', target: 'product-form-utility' },
      { text: 'tours.productForm.more', target: 'product-form-more' },
      { text: 'tours.productNew.stock', target: 'product-form-stock', whenMissing: 'center' },
      { text: 'tours.productNew.footer', target: 'product-form-footer' },
    ],
  },
  '/inventory/products/:id/edit': {
    key: 'screen-product-edit',
    steps: [
      { text: 'tours.productEdit.welcome' },
      { text: 'tours.productEdit.assign', target: 'product-form-assign' },
      { text: 'tours.productForm.data', target: 'product-form-data' },
      { text: 'tours.productForm.price', target: 'product-form-price' },
      { text: 'tours.productForm.utility', target: 'product-form-utility' },
      { text: 'tours.productForm.more', target: 'product-form-more' },
      { text: 'tours.productEdit.save', target: 'product-form-save' },
    ],
  },
  '/inventory/products/:id/assignments': {
    key: 'screen-product-assignments',
    steps: [
      { text: 'tours.productAssignments.welcome' },
      { text: 'tours.productAssignments.intro', target: 'product-assignments-intro' },
      { text: 'tours.productAssignments.table', target: 'product-assignments' },
      { text: 'tours.productAssignments.lends', target: 'product-assignments-col-active', whenMissing: 'center' },
      { text: 'tours.productAssignments.price', target: 'product-assignments-col-price', whenMissing: 'center' },
      { text: 'tours.productAssignments.actions', target: 'product-assignments-actions', whenMissing: 'center' },
      { text: 'tours.productAssignments.config', target: 'product-assignments-config' },
      { text: 'tours.productAssignments.save', target: 'product-assignments-save' },
    ],
  },
  '/inventory/products/by-route': {
    key: 'screen-products-by-route',
    steps: [
      { text: 'tours.productsByRoute.welcome' },
      { text: 'tours.productsByRoute.officeTypes' },
      { text: 'tours.productsByRoute.office', target: 'by-route-office' },
      { text: 'tours.productsByRoute.route', target: 'by-route-route' },
      { text: 'tours.productsByRoute.pending', target: 'by-route-pending' },
      { text: 'tours.productsByRoute.stats', target: 'by-route-stats', whenMissing: 'center' },
      { text: 'tours.productsByRoute.table', target: 'by-route', whenMissing: 'center' },
      { text: 'tours.productsByRoute.status', target: 'by-route-col-status', whenMissing: 'center' },
      { text: 'tours.productsByRoute.actions', target: 'by-route-actions', whenMissing: 'center' },
      { text: 'tours.productsByRoute.export', target: 'by-route-export' },
    ],
  },
  '/inventory/receipts': {
    key: 'screen-stock-receipts',
    steps: [
      { text: 'tours.receipts.welcome' },
      { text: 'tours.receipts.new', target: 'receipts-new' },
      { text: 'tours.receipts.dates', target: 'receipts-start' },
      { text: 'tours.receipts.office', target: 'receipts-office' },
      { text: 'tours.receipts.query', target: 'receipts-query' },
      { text: 'tours.receipts.search', target: 'receipts-search' },
      { text: 'tours.receipts.table', target: 'receipts' },
      { text: 'tours.receipts.actions', target: 'receipts-actions', whenMissing: 'center' },
      { text: 'tours.receipts.export', target: 'receipts-export' },
    ],
  },
  '/inventory/receipts/new': {
    key: 'screen-stock-receipt-new',
    steps: [
      { text: 'tours.receiptNew.welcome' },
      { text: 'tours.receiptNew.office', target: 'receipt-new-office' },
      { text: 'tours.receiptNew.route', target: 'receipt-new-route' },
      { text: 'tours.receiptNew.data', target: 'receipt-new-data' },
      { text: 'tours.receiptNew.line', target: 'receipt-new-line' },
      { text: 'tours.receiptNew.cost', target: 'receipt-new-cost' },
      { text: 'tours.receiptNew.add', target: 'receipt-new-add' },
      { text: 'tours.receiptNew.save', target: 'receipt-new-save' },
    ],
  },
  '/inventory/transfers': {
    key: 'screen-stock-transfers',
    steps: [
      { text: 'tours.transfers.welcome' },
      { text: 'tours.transfers.new', target: 'transfers-new' },
      { text: 'tours.transfers.dates', target: 'transfers-start' },
      { text: 'tours.transfers.office', target: 'transfers-office' },
      { text: 'tours.transfers.query', target: 'transfers-query' },
      { text: 'tours.transfers.search', target: 'transfers-search' },
      { text: 'tours.transfers.table', target: 'transfers' },
      { text: 'tours.transfers.items', target: 'transfers-col-items', whenMissing: 'center' },
      { text: 'tours.transfers.export', target: 'transfers-export' },
    ],
  },
  '/inventory/transfers/new': {
    key: 'screen-stock-transfer-new',
    steps: [
      { text: 'tours.transferNew.welcome' },
      { text: 'tours.transferNew.origin', target: 'transfer-new-origin-office' },
      { text: 'tours.transferNew.destination', target: 'transfer-new-destination-route' },
      { text: 'tours.transferNew.date', target: 'transfer-new-date' },
      { text: 'tours.transferNew.line', target: 'transfer-new-line' },
      { text: 'tours.transferNew.add', target: 'transfer-new-add' },
      { text: 'tours.transferNew.save', target: 'transfer-new-save' },
    ],
  },
  '/inventory/write-offs': {
    key: 'screen-write-offs',
    steps: [
      { text: 'tours.writeOffs.welcome' },
      { text: 'tours.writeOffs.tabs', target: 'write-offs-tabs' },
      { text: 'tours.writeOffs.location', target: 'write-offs-office' },
      { text: 'tours.writeOffs.product', target: 'write-offs-product' },
      { text: 'tours.writeOffs.from', target: 'write-offs-from' },
      { text: 'tours.writeOffs.lot', target: 'write-offs-lot' },
      { text: 'tours.writeOffs.quantity', target: 'write-offs-quantity' },
      { text: 'tours.writeOffs.reason', target: 'write-offs-reason' },
      { text: 'tours.writeOffs.save', target: 'write-offs-save' },
      { text: 'tours.writeOffs.status', target: 'write-offs-status', whenMissing: 'center' },
      { text: 'tours.writeOffs.history', target: 'write-offs-history', whenMissing: 'center' },
    ],
  },
  '/inventory/returns': {
    key: 'screen-product-returns',
    steps: [
      { text: 'tours.returns.welcome' },
      { text: 'tours.returns.tabs', target: 'returns-tabs' },
      { text: 'tours.returns.find', target: 'returns-find' },
      { text: 'tours.returns.loan', target: 'returns-loan', whenMissing: 'center' },
      { text: 'tours.returns.product', target: 'returns-product', whenMissing: 'center' },
      { text: 'tours.returns.condition', target: 'returns-condition', whenMissing: 'center' },
      { text: 'tours.returns.resolution', target: 'returns-resolution', whenMissing: 'center' },
      { text: 'tours.returns.save', target: 'returns-save', whenMissing: 'center' },
      { text: 'tours.returns.history', target: 'returns-history', whenMissing: 'center' },
    ],
  },
  '/inventory/stock': {
    key: 'screen-stock',
    steps: [
      { text: 'tours.stock.welcome' },
      { text: 'tours.stock.tabs', target: 'stock-tabs' },
      { text: 'tours.stock.location', target: 'stock-office' },
      { text: 'tours.stock.batches', target: 'stock-batches' },
      { text: 'tours.stock.stats', target: 'stock-stats', whenMissing: 'center' },
      { text: 'tours.stock.table', target: 'stock', whenMissing: 'center' },
      { text: 'tours.stock.kardex', target: 'kardex', whenMissing: 'center' },
      { text: 'tours.stock.expiring', target: 'expiring', whenMissing: 'center' },
    ],
  },
};
